import { EditableEntity, IPropEventBroker, IReadablePropEventBroker } from '@zdrbm/zdr-native-tools';

export interface IDrawerController {
  isOpen: IReadablePropEventBroker<boolean>;
  openDrawer(): void;
  closeDrawer(): void;
  toggleDrawer(): void;
}

export class DrawerController extends EditableEntity<keyof IDrawerController> implements IDrawerController {
  getEntityName(): string {
    return 'DrawerController';
  }

  isOpen: IPropEventBroker<boolean>;

  constructor() {
    super(undefined);

    this.isOpen = this.createPropEventBroker<boolean>('isOpen', false);
  }

  toggleDrawer(): void {
    this.isOpen.set(!this.isOpen.get());
  }

  openDrawer(): void {
    this.isOpen.set(true);
  }

  closeDrawer(): void {

    this.isOpen.set(false);
  }
}